module.exports = __webpack_public_path__ + "img/jquery-logo.d1e2fa5b.png";